import { render } from "./loading.svg?vue&type=template&id=631350ba"
const script = {}

import exportComponent from "/buddy/derek-lam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__